import type React from 'react';

interface SlackIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function SlackIcon({ size = 24, ...props }: SlackIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Slack_icon_2019" clipPath="url(#clip0_17071_188497)">
        <path
          id="Vector"
          d="M3.42675 10.0788C3.42675 10.9984 2.68345 11.7418 1.76376 11.7418C0.844076 11.7418 0.100769 10.9984 0.100769 10.0788C0.100769 9.15908 0.844076 8.41577 1.76376 8.41577H3.42675V10.0788ZM4.25825 10.0788C4.25825 9.15908 5.00156 8.41577 5.92124 8.41577C6.84093 8.41577 7.58423 9.15908 7.58423 10.0788V14.2362C7.58423 15.1559 6.84093 15.8992 5.92124 15.8992C5.00156 15.8992 4.25825 15.1559 4.25825 14.2362V10.0788Z"
          fill="#E01E5A"
        />
        <path
          id="Vector_2"
          d="M5.92127 3.40155C5.00158 3.40155 4.25827 2.65824 4.25827 1.73855C4.25827 0.818869 5.00158 0.0755615 5.92127 0.0755615C6.84095 0.0755615 7.58426 0.818869 7.58426 1.73855V3.40155H5.92127ZM5.92127 4.24564C6.84095 4.24564 7.58426 4.98895 7.58426 5.90863C7.58426 6.82832 6.84095 7.57162 5.92127 7.57162H1.75119C0.831503 7.57162 0.0881958 6.82832 0.0881958 5.90863C0.0881958 4.98895 0.831503 4.24564 1.75119 4.24564H5.92127Z"
          fill="#36C5F0"
        />
        <path
          id="Vector_3"
          d="M12.5858 5.90863C12.5858 4.98895 13.3291 4.24564 14.2488 4.24564C15.1685 4.24564 15.9118 4.98895 15.9118 5.90863C15.9118 6.82832 15.1685 7.57162 14.2488 7.57162H12.5858V5.90863ZM11.7543 5.90863C11.7543 6.82832 11.011 7.57162 10.0913 7.57162C9.17165 7.57162 8.42834 6.82832 8.42834 5.90863V1.73855C8.42834 0.818869 9.17165 0.0755615 10.0913 0.0755615C11.011 0.0755615 11.7543 0.818869 11.7543 1.73855V5.90863Z"
          fill="#2EB67D"
        />
        <path
          id="Vector_4"
          d="M10.0913 12.5733C11.011 12.5733 11.7543 13.3166 11.7543 14.2362C11.7543 15.1559 11.011 15.8992 10.0913 15.8992C9.17165 15.8992 8.42834 15.1559 8.42834 14.2362V12.5733H10.0913ZM10.0913 11.7418C9.17165 11.7418 8.42834 10.9984 8.42834 10.0788C8.42834 9.15908 9.17165 8.41577 10.0913 8.41577H14.2614C15.1811 8.41577 15.9244 9.15908 15.9244 10.0788C15.9244 10.9984 15.1811 11.7418 14.2614 11.7418H10.0913Z"
          fill="#ECB22E"
        />
      </g>
      <defs>
        <clipPath id="clip0_17071_188497">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
